import { render, staticRenderFns } from "./risk_list.vue?vue&type=template&id=a37e12ee"
import script from "./risk_list.vue?vue&type=script&lang=js"
export * from "./risk_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports